import { FC, useRef } from 'react';
import HotTable, { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { sortBy, toUpper } from 'lodash';
import { MEDIA_WEIGHTING_LIST } from 'pages/ListManagement/const';
import { CellValue, ICustomListData } from 'pages/ListManagement/types';
import { arrayToKeyValue } from 'utils/arrays';
import Grid from '../Grid';
import { MWeightingBannersHeader, translateHeaders, translateData } from './helpers/HeadersList';
import { requireTitle } from './helpers/utils';
import { NumberRenderer } from './helpers/customRenderers';
import { listValidator, numberValidator } from '../Validators';
import CustomDropboxRenderer from './helpers/CustomDropboxRenderer';

export const MWeightingBanners: FC<{
    list: IList;
    toolId: number;
}> = ({ list, toolId }) => {
    const translatedHeaders = translateHeaders(MWeightingBannersHeader);
    const translatedMediaWeightingList = translateData(MEDIA_WEIGHTING_LIST, 'list.header.');
    const hotRef = useRef<React.ElementRef<typeof HotTable> | null>(null);

    const listDropDown = MEDIA_WEIGHTING_LIST.map((id, i) => {
        return { id, name: translatedMediaWeightingList[i] };
    }) as unknown as ICustomListData[];
    const sortedRetailer = sortBy(listDropDown, [(o) => toUpper(o.name)]);

    const beforeDownload = (listToDownload: CellValue[][]) => {
        const keyValueRetailers = arrayToKeyValue(sortedRetailer, 'id');

        const newData = listToDownload.map((row) => {
            const newRow = [...row];
            newRow[0] = keyValueRetailers[newRow[0] as string].name;
            return newRow;
        });
        return newData;
    };

    return (
        <Grid
            toolId={toolId}
            headers={MWeightingBannersHeader}
            beforeDownload={beforeDownload}
            list={list}
            paramHotRef={hotRef}
        >
            <HotColumn validator={listValidator(MEDIA_WEIGHTING_LIST)} title={requireTitle(translatedHeaders[0])}>
                <CustomDropboxRenderer customList={sortedRetailer} hotInstance={hotRef} hot-renderer />
            </HotColumn>

            <HotColumn
                allowEmpty={false}
                title={requireTitle(translatedHeaders[1])}
                type="text"
                validator={numberValidator()}
            >
                <NumberRenderer hot-renderer />
            </HotColumn>
        </Grid>
    );
};
